import { Grid } from '@mui/material';
import styled from 'styled-components';
import { breakpoints } from '../../../../../../../theme/breakpoints';
import { colors } from '../../../../../../../theme/styles';

export const Content = styled(Grid)`
  #button-group {
    margin-bottom: 1rem;
    width: 100%;

    button {
      width: 100%;
      margin-top: 1rem;

      @media (min-width: ${breakpoints.md}) {
        margin-right: 1rem;
        width: 25%;
      }
    }
  }

  #allSwitches {
    margin-bottom: 1rem;
  }

  .column {
    display: flex;
    flex-direction: column;
    text-transform: capitalize;
  }

  .twoButtons {
    margin-top: 1rem;
  }
`;

export const CategoryContainer = styled.div`
  margin-top: 1.5rem;

  p {
    color: ${colors.theme.primary};
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  div {
    display: flex;
    flex-direction: column;
  }
`;
